module.exports = __webpack_public_path__ + "img/Jump Casting86.5bb33de6.jpg";